import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FaTrash } from "react-icons/fa"; // ✅ Import the correct delete icon
import { toast, ToastContainer } from "react-toastify";
import userSignaturesService from "../../../api/userSignatures";

const CustomSignatureField = ({ customFields, setCustomFields }) => {
  const [inputValue, setInputValue] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const fetchTextSignatures = async () => {
    try {
      const res = await userSignaturesService.getSignatures(
        user?.userId,
        "TEXT",
      );

      if (res.data && res.data.length > 0) {
        setCustomFields(
          res.data.map((sig) => ({
            id: sig.id,
            text: sig.signatureText,
          })),
        );
      }
    } catch (error) {
      if (error.response?.status !== 404) {
        toast.error("Error fetching existing signatures.");
      }
    }
  };

  useEffect(() => {
    fetchTextSignatures();
  }, []);

  const handleGenerate = async () => {
    if (!inputValue.trim()) return;

    try {
      await userSignaturesService.saveTextSignature({
        userId: user?.userId,
        text: inputValue.trim(),
      });

      toast.success("Signature saved successfully!");

      // Update local state for UI
      setCustomFields([
        ...customFields,
        { id: Date.now(), text: inputValue.trim() },
      ]);
      setInputValue("");
    } catch (error) {
      if (error.response?.status === 409) {
        toast.info(error.response.data);
      } else {
        toast.error("Failed to save signature.");
      }
    }
  };

  const handleDragStart = (e, id, text) => {
    e.dataTransfer.setData("text/plain", text);
    e.dataTransfer.setData("fieldType", "TEXT");
  };

  const handleDelete = async () => {
    try {
      await userSignaturesService.softDeleteSignature(user?.userId, "TEXT");

      await fetchTextSignatures();

      toast.success("Signature deleted successfully!");
    } catch (error) {
      console.error("Error deleting signature:", error);
      toast.error("Failed to delete signature.");
    }
  };

  return (
    <div>
      <h4>Custom Signature Field</h4>
      <input
        type="text"
        placeholder="Custom Signature Field"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        style={{
          width: "90%",
          height: "40px",
          padding: "0",
          marginBottom: "10px",
          border: "none",
        }}
      />
      <Button onClick={handleGenerate} disabled={!inputValue.trim()}>
        Generate
      </Button>

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        {customFields.map((field, index) => (
          <div
            key={index}
            draggable
            onDragStart={(e) => handleDragStart(e, field.id, field.text)}
            style={{
              display: "flex", // ✅ Make field and icon in row
              alignItems: "center", // vertically align text and icon
              padding: "6px 10px",
              backgroundColor: "#ddd",
              cursor: "grab",
              userSelect: "none",
              borderRadius: "4px",
              gap: "6px", // space between text and icon
            }}
          >
            <span>{field.text}</span>
            <Button
              variant="danger"
              size="sm"
              onClick={() => handleDelete(field.id)} // pass id for per-field delete
              style={{ padding: "2px 6px", cursor: "pointer" }}
            >
              <FaTrash />
            </Button>
          </div>
        ))}
      </div>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
      />
    </div>
  );
};

export default CustomSignatureField;
